import { Trans } from "react-i18next";

const News4 = () => {
    return (
        <Trans
            i18nKey={"Dashboard##news##body##4"}
            components={{
                section: <section />,
                h3: <h3>""</h3>, // fake empty content to avoid warnings
                p: <p />,
                ul: <ul />,
                li: <li />,
                strong: <strong />
            }}
        />
    );
};

export { News4 };
